import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from '../ui/tooltip';

/** Hover/focus names plus a cancellable long press that never navigates. */
export default function OfficeRailHint({ label, children }) {
  const [open, setOpen] = useState(false);
  const timer = useRef();
  const dismiss = useRef();
  const touch = useRef(null);
  const held = useRef(false);
  const clear = () => { clearTimeout(timer.current); clearTimeout(dismiss.current); };
  useEffect(() => () => { clearTimeout(timer.current); clearTimeout(dismiss.current); }, []);
  return <Tooltip open={open} onOpenChange={value => { if (!touch.current) setOpen(value); }}>
    <TooltipTrigger asChild
      onPointerDown={event => {
        if (event.pointerType === 'mouse') return;
        clear(); held.current = false;
        touch.current = { x: event.clientX, y: event.clientY };
        timer.current = setTimeout(() => { held.current = true; setOpen(true); }, 450);
      }}
      onPointerMove={event => {
        const start = touch.current;
        if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10) {
          clear(); touch.current = null; held.current = false; setOpen(false);
        }
      }}
      onPointerUp={() => {
        clearTimeout(timer.current); touch.current = null;
        if (held.current) dismiss.current = setTimeout(() => { setOpen(false); held.current = false; }, 2000);
      }}
      onPointerCancel={() => { clear(); touch.current = null; held.current = false; setOpen(false); }}
      onClickCapture={event => {
        if (held.current) { event.preventDefault(); event.stopPropagation(); held.current = false; }
      }}
      onContextMenu={event => { if (touch.current || held.current) event.preventDefault(); }}
      onBlur={() => { clear(); touch.current = null; held.current = false; setOpen(false); }}
    >{children}</TooltipTrigger>
    <TooltipContent side="right" sideOffset={12} collisionPadding={12} className="office-chat-rail-hint">{label}</TooltipContent>
  </Tooltip>;
}
